var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vuestic-widget", { attrs: { headerText: "Progress Bars" } }, [
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("progressBars.basic")) + "\n      "
          ),
          _c("vuestic-progress-bar", {
            attrs: { value: _vm.value, animated: "" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v("\n      " + _vm._s(_vm.$t("progressBars.thin")) + "\n      "),
          _c("vuestic-progress-bar", {
            attrs: { value: _vm.value, size: "thin", animated: "" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex sm4 md4" },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("progressBars.thick")) + "\n      "
          ),
          _c("vuestic-progress-bar", {
            attrs: { value: _vm.value, size: "thick", animated: "" },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "va-row" }, [
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("progressBars.basicVertical")) + "\n      "
        ),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: { value: _vm.value, type: "vertical", animated: "" },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("progressBars.thinVertical")) + "\n      "
        ),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: {
                value: _vm.value,
                size: "thin",
                type: "vertical",
                animated: "",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex sm4 md4" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("progressBars.circle")) + "\n      "),
        _c(
          "div",
          { staticClass: "pb-container" },
          [
            _c("vuestic-progress-bar", {
              attrs: { value: _vm.value, type: "circle", animated: "" },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }